
import Animation from '@/components/Animation'
import HTMLRender from '@/components/HTMLRender'
import utils from '@/mixins/utils'
export default {
  mixins: [utils],
  components: {
    Animation,
    HTMLRender,
  },
  data() {
    return {
      edjsParser: null,
    }
  },

  props: {
    data: {
      type: Object,
      default: () => {
        return null
      },
    },
  },

  mounted() {
    if (window && this.data.text && this.data.text.includes('[booking')) {
      if (window.HOLDBAR) {
        setTimeout(() => {
          const widget = this.$refs.render.$el.getElementsByClassName(
            'holdbar-booking-widget'
          )
          const currLang = window.Weglot.getCurrentLang() || 'en'
          const widgetLang = widget[0].dataset.language
          if (widgetLang !== currLang) {
            widget[0].dataset.language = currLang
          }

          if (widget[0] && !widget[0].shadowRoot) {
            window.HOLDBAR.initialize()
          }
        }, 500)
      }
    }
  },
}
